module.exports = __webpack_public_path__ + "static/media/29.f6901311.JPG";